/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-max-range',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoMaxRangeComponent extends NestedOption {
    @Input()
    get days(): number {
        return this._getOption('days');
    }
    set days(value: number) {
        this._setOption('days', value);
    }

    @Input()
    get hours(): number {
        return this._getOption('hours');
    }
    set hours(value: number) {
        this._setOption('hours', value);
    }

    @Input()
    get milliseconds(): number {
        return this._getOption('milliseconds');
    }
    set milliseconds(value: number) {
        this._setOption('milliseconds', value);
    }

    @Input()
    get minutes(): number {
        return this._getOption('minutes');
    }
    set minutes(value: number) {
        this._setOption('minutes', value);
    }

    @Input()
    get months(): number {
        return this._getOption('months');
    }
    set months(value: number) {
        this._setOption('months', value);
    }

    @Input()
    get quarters(): number {
        return this._getOption('quarters');
    }
    set quarters(value: number) {
        this._setOption('quarters', value);
    }

    @Input()
    get seconds(): number {
        return this._getOption('seconds');
    }
    set seconds(value: number) {
        this._setOption('seconds', value);
    }

    @Input()
    get weeks(): number {
        return this._getOption('weeks');
    }
    set weeks(value: number) {
        this._setOption('weeks', value);
    }

    @Input()
    get years(): number {
        return this._getOption('years');
    }
    set years(value: number) {
        this._setOption('years', value);
    }


    protected get _optionPath() {
        return 'maxRange';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoMaxRangeComponent
  ],
  exports: [
    DxoMaxRangeComponent
  ],
})
export class DxoMaxRangeModule { }
